import React, { Component } from "react";
import Grid from "../../../../../../components/grid";
import RadiosRenderer from "../../../../../../components/grid/RadiosRenderer";
//import scss
import "./earningCodes.scss";
class EarningCodes extends Component {
  constructor(props) {
    super(props)
  };

  state = {
    columnDefs: [

      {
        headerName: "Earning Code",
        field: "earningCode",
        width: 135,

      },
      {
        headerName: "Earning Type",
        field: "earningType",
        resizable: true,
        width: 435,
        cellRenderer: RadiosRenderer,
        cellRendererParams: {
          onChange: params => this.props.onTypeChange(params, this.state.earningCodes),
          radioValues: [
            { val: "regRG", label: "Regular" },
            { val: "regOT", label: "Overtime" },
            { val: "PTO", label: "PTO" },
            { val: "holidayRG", label: "Holiday" },
            { val: "holidayOT", label: "Holiday OT" }],
          nameProp: "systemId"
        },
      }

    ],
    rowData: [],
    earningCodes: []
  };

  async componentDidMount() {
    this.setState({ earningCodes: this.props.mappedEarningCodes });
  };

  async componentDidUpdate(prevProps, prevState) {
    if ((!prevProps.mappedEarningCodes || !prevProps.mappedEarningCodes.length) && this.props.mappedEarningCodes && this.props.mappedEarningCodes.length) {
      this.setState({ earningCodes: this.props.mappedEarningCodes });
    };
  };

  onChange = value => {
    return this.props.onChange(value);
  }

  render() {
    return (
      <>
        <div className="full-box mt-0">
          <div className="clients_grid">
            <Grid
              columnDefs={this.state.columnDefs}
              rowData={this.state.earningCodes}
              height='600px'
            >
            </Grid>
          </div>
        </div>
      </>
    );
  };
};


export default EarningCodes;